var CryptoJS = require("crypto-js");
import { Buffer } from "buffer";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import pako from "pako";
import Enums from "../enums/enums";
import i18n from "../locales/i18n";

const peakDomain = process.env.VUE_APP_PeakDomain;
const secretKeyAESIndexedDbCash = "peakIndexedDbCash";

function DetectTabClosing(e) {
  e.preventDefault();
  var confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export const UrlCombine = (uri, ...segments) => {
  if (!uri || !uri.trim()) {
    return null;
  }

  if (!segments.length) {
    return uri;
  }

  let baseUri;
  try {
    baseUri = new URL(uri);
  } catch (error) {
    console.error("Invalid base URI:", uri, error);
    return null;
  }

  return segments.reduce((current, segment) => {
    const trimmedCurrent = current.trimEnd("/");
    const trimmedSegment = segment.trimStart("/");
    return `${trimmedCurrent}/${trimmedSegment}`;
  }, baseUri.toString());
};

export const GetIsDevelop = () => {
  return process.env.VUE_APP_TYPE_ENV <= Enums.EnvironmentType.SIT;
};

export const GetIsUAT = () => {
  return process.env.VUE_APP_TYPE_ENV == Enums.EnvironmentType.UAT;
};

export const GetIsProduction = () => {
  return process.env.VUE_APP_TYPE_ENV >= Enums.EnvironmentType.Staging;
};

export const EncryptionIndexedDbCash = (cashString) => {
  if (cashString) {
    const encrypted = CryptoJS.AES.encrypt(cashString.toString(), secretKeyAESIndexedDbCash);
    return encrypted.toString();
  }
  return "";
};

export const DecryptionIndexedDbCash = (encryptCashString) => {
  if (encryptCashString) {
    const originalMessage = CryptoJS.AES.decrypt(encryptCashString, secretKeyAESIndexedDbCash);
    return originalMessage.toString(CryptoJS.enc.Utf8);
  }
  return "";
};

export const DecompressZlipData = (compressedData) => {
  if (!compressedData) return "";
  try {
    const binaryData = Uint8Array.from(atob(compressedData), (byte) => byte.charCodeAt(0));
    const decompressedData = pako.inflateRaw(binaryData, { to: "string" });
    return decompressedData;
  } catch (error) {
    return "";
  }
};

export function GetFormatNumberWithCommas(number) {
  if (typeof number !== "number" && number === NaN) {
    return "0";
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export async function Delay(ms = 100) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function GetTransactionName(
  transactionType,
  financeType,
  transactionItemType,
  expenseType,
  isLowerCase = false
) {
  let name = "";

  const isExpense = expenseType === Enums.ExpenseType.Expense;
  const isService = transactionItemType === Enums.TransactionItemType.Service;
  const isInventory =
    transactionItemType === Enums.TransactionItemType.Inventory || expenseType === Enums.ExpenseType.PurchaseInventory;
  const isAsset =
    transactionItemType === Enums.TransactionItemType.Asset || expenseType === Enums.ExpenseType.PurchaseAsset;

  if (financeType === Enums.FinanceType.InFlow) {
    switch (transactionType) {
      case Enums.TransactionType.Quotation:
        name = i18n.t("Quotation");
        break;
      case Enums.TransactionType.Invoice:
        name = isAsset ? i18n.t("Sell_Asset_Invoice") : i18n.t("Invoice");
        break;
      case Enums.TransactionType.Receipt:
        name = isAsset ? i18n.t("Sell_Asset_Receipt") : i18n.t("Receipt");
        break;
      case Enums.TransactionType.TaxInvoice:
        name = i18n.t("Sales_Tax_Invoice");
        break;
      case Enums.TransactionType.CreditNote:
        name = i18n.t("Credit_Note");
        break;
      case Enums.TransactionType.BillingNote:
        name = i18n.t("Billing_Note");
        break;
      case Enums.TransactionType.DebitNote:
        name = i18n.t("Debit_Note");
        break;
      case Enums.TransactionType.Deposit:
        name = i18n.t("Deposit_Receipt");
        break;
    }
  } else if (financeType === Enums.FinanceType.OutFlow) {
    switch (transactionType) {
      case Enums.TransactionType.Quotation:
        name = isAsset ? i18n.t("Purchase_Order_Asset") : i18n.t("Purchase_Order");
        break;
      case Enums.TransactionType.Invoice:
        name = isAsset
          ? i18n.t("Purchase_Asset_Record")
          : isExpense
          ? i18n.t("Expense_Record")
          : i18n.t("Purchase_Inventory_Record");
        break;
      case Enums.TransactionType.TaxInvoice:
        name = i18n.t("Purchase_Tax_Invoice");
        break;
      case Enums.TransactionType.CreditNote:
        name = i18n.t("Receive_Credit_Note");
        break;
      case Enums.TransactionType.BillingNote:
        name = i18n.t("Combined_Payment_Note");
        break;
      case Enums.TransactionType.DebitNote:
        name = i18n.t("Receive_Debit_Note");
        break;
      case Enums.TransactionType.Deposit:
        name = i18n.t("Deposit_Payment");
        break;
      case Enums.TransactionType.GoodsReceipt:
        name = i18n.t("Goods_Receipt");
        break;
      case Enums.TransactionType.InvoiceReceipt:
        name = i18n.t("Invoice_Receipt");
        break;
      case Enums.TransactionType.PurchaseRequisition:
        name = i18n.t("Purchase_Requisition");
        break;
    }
  } else {
    switch (transactionType) {
      case Enums.TransactionType.Dailyjournal:
        name = i18n.t("Daily_Journal");
        break;
    }
  }

  return isLowerCase ? name.toLocaleLowerCase() : name;
}

export default {
  GetExcelDateTime(excelDate) {
    if (!excelDate) {
      return "";
    }
    if (!isNaN(new Date(excelDate).getTime())) {
      return new Date(excelDate);
    } else if (dayjs(excelDate).isValid()) {
      return dayjs(excelDate).format("YYYY-MM-DD");
    } else {
      let dt = new Date(1900, 0, 0);
      dt.setDate(dt.getDate() - 1 + excelDate);
      return !isNaN(dt.getTime()) ? dt : new Date().ToDateJsonString();
    }
  },
  GetExcelDateTimeForTikTokAndFoodStory(excelDate) {
    if (!excelDate) {
      return "";
    }
    let formattedDateTime;
    if (excelDate) {
      let excelDateParts = excelDate.split(" ");
      let dateParts = excelDateParts[0].split("/");

      const year = dateParts[2];
      const month = dateParts[1] - 1;
      const day = dateParts[0];

      formattedDateTime = new Date(year, month, day);
    }
    return !isNaN(formattedDateTime) ? formattedDateTime.ToDateJsonString() : null;
  },
  GetBankTypeForZwiz(bankType) {
    if (!bankType) {
      return "other";
    }
    const cleanedBankType = bankType.trim().toLowerCase();
    return cleanedBankType;
  },
  CreateToken(userId) {
    const secret = "puuntrueincube210414";
    let message = userId.toString();
    var hash = CryptoJS.HmacSHA256(message, secret);
    var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  },
  PrepareToInsertUserProfileConsent(userId, isConsentTerm) {
    let input = {
      userId: userId,
      isConsentTerm: isConsentTerm,
    };
    return input;
  },
  CreateIntercomHash(userId) {
    const secret = process.env.VUE_APP_PeakIntercomSecret;
    let message = userId.toString();
    var hash = CryptoJS.HmacSHA256(message, secret);
    return hash.toString(CryptoJS.enc.Hex);
  },
  ChangeNameByLanguageType(account) {
    if (i18n.locale === Enums.LanguageType.English) {
      account.name.locale = account.name.english;
      account.accountTypeSecondaryName.locale = account.accountTypeSecondaryName.english;
    } else {
      account.name.locale = account.name.thai;
      account.accountTypeSecondaryName.locale = account.accountTypeSecondaryName.thai;
    }
  },
  GetAccountListForMap(accountList) {
    const accountForMap = new Map();
    if (accountList && accountList.length > 0) {
      for (let account of accountList) {
        this.ChangeNameByLanguageType(account);
        accountForMap.set(account.id, account);
      }
    }
    return accountForMap;
  },
  GetTransactionLabel(transactionTypeModel) {
    switch (transactionTypeModel.transactionType) {
      case Enums.TransactionType.Quotation: {
        if (transactionTypeModel.financeType == Enums.FinanceType.InFlow) {
          return "Option_Quotation";
        } else if (transactionTypeModel.financeType == Enums.FinanceType.OutFlow) {
          return "Option_Purchase_Order";
        }
        break;
      }
      case Enums.TransactionType.Invoice: {
        if (transactionTypeModel.financeType == Enums.FinanceType.InFlow) {
          return "Option_Invoice";
        } else if (transactionTypeModel.financeType == Enums.FinanceType.OutFlow) {
          if (transactionTypeModel.expenseType == Enums.ExpenseType.Expense) {
            return "Option_Expenses_Record";
          } else if (transactionTypeModel.expenseType == Enums.ExpenseType.PurchaseInventory) {
            return "Option_Purchase_Inventory";
          } else if (transactionTypeModel.expenseType == Enums.ExpenseType.PurchaseAsset) {
            return "Option_Purchase_Asset";
          }
        }
        break;
      }
      case Enums.TransactionType.Receipt: {
        return "Option_Receipt";
        break;
      }
    }
  },
  GetLockDescription(lockStatus, lockDateTime) {
    let lockDescription = "";
    switch (lockStatus) {
      case Enums.LockStatusType.LockByPeriod:
        lockDescription = "ถูกล๊อคโดยช่วงเวลา เมื่อ " + lockDateTime;
        break;
      case Enums.LockStatusType.LockBySystem:
        lockDescription = "ถูกล๊อคโดยระบบ";
        break;
      case Enums.LockStatusType.LockByUser:
        lockDescription = "ถูกล๊อคโดยผู้ใช้งาน";
        break;
    }
  },
  SetDateForInputDate(date, isActiveDay = true) {
    let output = "";
    let dateStr = date;
    let dateArray = [];
    let yearFirstDateArray = [];
    let slash = dateStr.includes("/");
    let minus = dateStr.includes("-");
    const minDateSystem = new Date(null);
    minDateSystem.setHours(0, 0, 0, 0);
    if (slash) {
      dateArray = dateStr.split("/");
      yearFirstDateArray = dateStr.split("/");
    } else if (minus) {
      dateArray = dateStr.split("-");
      yearFirstDateArray = dateStr.split("-");
    } else if (dateStr.length <= 8) {
      if (isActiveDay) {
        dateArray.push(dateStr.substr(0, 2));
        dateArray.push(dateStr.substr(2, 2));
        dateArray.push(dateStr.substr(4, 4));

        yearFirstDateArray.push(dateStr.substr(0, 4));
        yearFirstDateArray.push(dateStr.substr(4, 2));
        yearFirstDateArray.push(dateStr.substr(6, 2));
      } else {
        dateArray.push(dateStr.substr(0, 2));
        dateArray.push(dateStr.substr(2, 4));

        yearFirstDateArray.push(dateStr.substr(0, 4));
        yearFirstDateArray.push(dateStr.substr(4, 2));
      }
    } else {
      dateArray = [];
    }
    let day, month, year;
    if (
      yearFirstDateArray.length > 1 &&
      parseInt(yearFirstDateArray[1]) <= 12 &&
      parseInt(yearFirstDateArray[0]) > 1700
    ) {
      if (isActiveDay) {
        day = parseInt(yearFirstDateArray[2]);
        month = parseInt(yearFirstDateArray[1]);
      } else {
        day = 1;
        month = parseInt(yearFirstDateArray[1]);
      }
      year = parseInt(yearFirstDateArray[0]);
      if (year > 2500) {
        year = year - 543;
      }
      let getDaysInMonth = new Date(year, month, 0).getDate();
      if (day <= getDaysInMonth && year <= 9999) {
        output = new Date(year, month - 1, day);
        output.setHours(0, 0, 0, 0);
        if (output.getTime() < minDateSystem.getTime()) {
          output = "";
        }
      } else {
        output = "";
      }
    }
    if (dateArray.length > 1 && output === "") {
      if (isActiveDay) {
        day = parseInt(dateArray[0]);
        month = parseInt(dateArray[1]);
      } else {
        day = 1;
        month = parseInt(dateArray[0]);
      }
      if (month <= 12) {
        if (isActiveDay && dateArray[2]) {
          year = parseInt(dateArray[2]);
          if (year > 2500) {
            year = year - 543;
          }
        } else if (!isActiveDay && dateArray[1]) {
          year = parseInt(dateArray[1]);
          if (year > 2500) {
            year = year - 543;
          }
        } else {
          year = new Date().getFullYear();
        }
        let getDaysInMonth = new Date(year, month, 0).getDate();
        if (day <= getDaysInMonth && year <= 9999) {
          output = new Date(year, month - 1, day);
          output.setHours(0, 0, 0, 0);
          if (output.getTime() < minDateSystem.getTime()) {
            output = "";
          }
        } else {
          output = "";
        }
      } else {
        output = "";
      }
    }
    return output;
  },
  GetErrorMessageByExceptionCode(exception) {
    let errorMessage = "";
    switch (exception ? exception.code : null) {
      case Enums.PeakExceptionResponseCode.ContactNotFound:
        errorMessage = i18n.t("Select_Contact_Failed_Because_Contact_Was_Archived");
        break;
      case Enums.PeakExceptionResponseCode.TransactionNumberDuplicated:
        errorMessage = i18n.t("Duplicated_Document_Number");
        break;
      case Enums.PeakExceptionResponseCode.ReceivedTaxInvoiceNumberDuplicated:
        errorMessage = i18n.t("Duplicated_ReceivedTaxInvoice_Number");
        break;
      case Enums.PeakExceptionResponseCode.ImportTransactionExceed:
        errorMessage = i18n.t("ImportTransaction_Exceed");
        break;
      case Enums.PeakExceptionResponseCode.LockByPeriod:
        errorMessage = i18n.t("Lock_old_entries", { date: exception.content.GetDateFormat() });
        break;
      case Enums.PeakExceptionResponseCode.ProPlusImportTransaction:
        errorMessage = i18n.t("ProPlus_ImportTransaction");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditInvoiceIsIssuedDebitNote:
        errorMessage = i18n.t("Edit_Invoice_DebitNote_Error");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditInvoiceIsIssuedCreditNote:
        errorMessage = i18n.t("Edit_Invoice_CreditNote_Error");
        break;
      case Enums.PeakExceptionResponseCode.CanNotUpdateJournalStatus:
        errorMessage = i18n.t("Modal_Multiple_Approve.Unable_Approve");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedCreditNote:
        errorMessage = i18n.t("Void_Invoice_CreditNote_Error");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidInvoiceIsIssuedDebitNote:
        errorMessage = i18n.t("Void_Invoice_DebitNote_Error");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidReceiptIsIssuedDebitNote:
        errorMessage = i18n.t("Void_Receipt_DebitNote_Error");
        break;
      case Enums.PeakExceptionResponseCode.LockByIssuedPP30:
        errorMessage = exception.errorMessage ? i18n.t("Lock_By_Issued_PP30") : i18n.t("Alert_Lock_By_Issued_PP30");
        break;
      case Enums.PeakExceptionResponseCode.LockByUser:
      case Enums.PeakExceptionResponseCode.LockBySystem:
        errorMessage = i18n.t("Exception_Journal_Lock");
        break;
      case Enums.PeakExceptionResponseCode.CanNotIsArchivedAllocationIncome:
        errorMessage = i18n.t("AlertNoti_Classification_Activate_Limit");
        break;
      case Enums.PeakExceptionResponseCode.CanNotIsArchivedAllocationExpense:
        errorMessage = i18n.t("AlertNoti_Classification_Activate_Limit");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidAllocation:
        errorMessage = i18n.t("Can_Not_Void_Allocation");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidAllocationItem:
        errorMessage = i18n.t("Can_Not_Void_Allocation_Item");
        break;
      case Enums.PeakExceptionResponseCode.OverInvitationUser:
        errorMessage = i18n.t("Over_Invitation_User");
        break;
      case Enums.PeakExceptionResponseCode.UserAlreadyMerchant:
        errorMessage = i18n.t("User_Already_Merchant");
        break;
      case Enums.PeakExceptionResponseCode.MerchantPackageIsNotAddUser:
        errorMessage = i18n.t("Merchant_Package_Is_Not_Add_User");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditSuperUser:
        errorMessage = i18n.t("Edit_Rights_Failed_Because_User_Created_Organization");
        break;
      case Enums.PeakExceptionResponseCode.UserUpdateEqualEditUser:
        errorMessage = i18n.t("Edit_User_Rights_Failed_Because_Is_Your_User");
        break;
      case Enums.PeakExceptionResponseCode.CanNotRemoveSuperUser:
        errorMessage = i18n.t("Delete_User_Failed_Because_User_Created_Organization");
        break;
      case Enums.PeakExceptionResponseCode.CanNotRemoveUser:
        errorMessage = i18n.t("Delete_User_Failed_Because_Is_Your_User");
        break;
      case Enums.PeakExceptionResponseCode.InvalidINetAuthenticationData:
        errorMessage = i18n.t("Invalid_INet_AuthenticationData");
        break;
      case Enums.PeakExceptionResponseCode.CanNotAddNewPriceToProductService:
        errorMessage = i18n.t("Add_pricing_up_to_10_items");
        break;
      case Enums.PeakExceptionResponseCode.ProductServicePriceNameDuplicated:
        errorMessage = i18n.t("Pricing_name_duplicate");
        break;
      case Enums.PeakExceptionResponseCode.CannotVoidPaymentHavePND:
        errorMessage = i18n.t("Cant_Void_Payment_HavePND");
        break;
      case Enums.PeakExceptionResponseCode.FullPaymentAmount:
        errorMessage = i18n.t("Should_Do_Full_Payment");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidTransactionIsHaveReferenceDocumentPayment:
        errorMessage = i18n.t("Can_Not_Void_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote:
        errorMessage = i18n.t("Can_Not_Create_CreditNote_Because_Transaction_Issued_DebitNote");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt:
        errorMessage = i18n.t("Can_Not_Create_CreditNote_Because_Transaction_No_Debt");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote:
        errorMessage = i18n.t("Can_Not_Create_DebitNote_Because_Transaction_Issued_CreditNote");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditTransactionIsIssuedReferencePaymentDocument:
        errorMessage = i18n.t("Lock_By_Payment_Tooltip");
        break;
      case Enums.PeakExceptionResponseCode.OverCreditNoteAmount:
        errorMessage = i18n.t("Can_Not_Create_Creditnote_And_Do_Creditnote_Amount_More_Reference_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.ProductTemplateCodeIsDuplicated:
        errorMessage = i18n.t("Create_product_failed_because_product_code_is_duplicated");
        break;
      case Enums.PeakExceptionResponseCode.ProductNameAndDescriptionIsDuplicated:
        errorMessage = i18n.t("Create_product_failed_because_product_name_is_duplicated");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidProductTemplate:
        errorMessage = i18n.t("Cannot_Void_Product");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidBillingNoteBecausePaid:
        errorMessage = i18n.t("You_Can_Not_Delete_Bcause_Document_Paid");
        break;
      case Enums.PeakExceptionResponseCode.MerchantIsVerified:
        errorMessage = i18n.t("Notification_Verified_Merchant");
        break;
      case Enums.PeakExceptionResponseCode.LockByIssuedPND3:
        errorMessage = i18n.t("Alert_Lock_By_Issued_PND3");
        break;
      case Enums.PeakExceptionResponseCode.LockByIssuedPND53:
        errorMessage = i18n.t("Alert_Lock_By_Issued_PND53");
        break;
      case Enums.PeakExceptionResponseCode.FreePackageOverCreateTransaction:
        errorMessage = i18n.t("Free_Package_Over_Create_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.BillingAmountCannotBeGreaterThanOutstandingBalanceOfTheDocument:
        errorMessage = i18n.t("Billing_Amount_Cannot_Be_Greater_Than_The_Outstanding_Balance_Of_The_Document");
        break;
      case Enums.PeakExceptionResponseCode.CanNotBePaid:
        errorMessage = i18n.t("Can_Not_Be_Paid");
        break;
      case Enums.PeakExceptionResponseCode.OverPaid:
        errorMessage = i18n.t("Payment_Cannot_Be_Over_Document");
        break;
      case Enums.PeakExceptionResponseCode.AccountingFirmDeleted:
        errorMessage = i18n.t("AccoutingFirm_Was_Deleted");
        break;
      case Enums.PeakExceptionResponseCode.NotHaveAfpRefCode:
        errorMessage = i18n.t("Invalid_Afp_Ref_Code");
        break;
      case Enums.PeakExceptionResponseCode.AccountingFirmRegisted:
        errorMessage = i18n.t("AccoutingFirm_Was_Registed");
        break;
      case Enums.PeakExceptionResponseCode.NotHaveAccountingFirmMerchant:
        errorMessage = i18n.t("AccoutingFirm_Merchant_Not_Found");
        break;
      case Enums.PeakExceptionResponseCode.AccountingFirmMerchantDeleted:
        errorMessage = i18n.t("AccoutingFirm_merchant_Was_Deleted");
        break;
      case Enums.PeakExceptionResponseCode.DuplicatedSaleAsset:
        errorMessage = i18n.t("Alert_DuplicatedSaleAsset");
        break;
      case Enums.PeakExceptionResponseCode.ValidateProductMustHaveAccountId:
        errorMessage = i18n.t("Validate_Product_Must_Have_Account");
        break;
      case Enums.PeakExceptionResponseCode.JournalAccountDescriptionIsEmptryOrNull:
        errorMessage = i18n.t("Description_ProductList_InputEmptryOrNull");
        break;
      case Enums.PeakExceptionResponseCode.JournalModelNotFound:
        errorMessage = i18n.t("Alert_JournalModelNotFound");
        break;
      case Enums.PeakExceptionResponseCode.ProPlusRecurringTransaction:
        errorMessage = i18n.t("ProPlus_Recurring_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.BasicCreateJournal:
        errorMessage = i18n.t("Basic_CreateJournal");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateCreditNoteBecauseReferenceTransactionTypeAsset:
        errorMessage = i18n.t("Can_Not_Create_CreditNote_ReferenceTransactionTypeAsset");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateDebitNoteBecauseReferenceTransactionTypeAsset:
        errorMessage = i18n.t("Can_Not_Create_DebitNote_ReferenceTransactionTypeAsset");
        break;
      case Enums.PeakExceptionResponseCode.NotHavePurchaseAccountAndSellAccountForProductTemplate:
        errorMessage = i18n.t("Text_PleaseSpecifySelingAndPurchasing");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidPayment:
        errorMessage = i18n.t("Confirm_cannot_delete_finance");
        break;
      case Enums.PeakExceptionResponseCode.CanNotDeleteContact:
        errorMessage = i18n.t("Header_ConfirmDeleteContact_Cant");
        break;
      case Enums.PeakExceptionResponseCode.TaxInvoiceNumberDuplicated:
        errorMessage = i18n.t("The_Sales_Tax_Invoice_Number_Duplicate");
        break;
      case Enums.PeakExceptionResponseCode.AssetPurchaseDateLessThanStopAssetDepreciationDate:
        errorMessage = i18n.t("Assets_Cannot_Be_Sold");
        break;
      case Enums.PeakExceptionResponseCode.CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate:
        errorMessage = i18n.t("Asset_Can_Be_Sold");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateDuplicatedReceiptFromReferenceTransaction:
        errorMessage = i18n.t("Alert_CanNotCreateDuplicatedReceipt");
        break;
      case Enums.PeakExceptionResponseCode.CreditNoteDateLessThanReferenceTransactionDate:
        errorMessage = i18n.t("CreditNote_Date_Less_Than_Reference_Transaction_Date");
        break;
      case Enums.PeakExceptionResponseCode.PackageErrorCode:
        errorMessage = i18n.t("Package_Error_Payment_Unpaid");
        break;
      case Enums.PeakExceptionResponseCode.SCBQRPaymentCodeModelNotFound:
        errorMessage = i18n.t("Please_Connect_Banking");
        break;
      case Enums.PeakExceptionResponseCode.MerchantDeleteAlready:
        errorMessage = i18n.t("Merchant_Already_Deleted");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateContactHaveMaximumContact:
        errorMessage = i18n.t("Alert_CantCreateContactMaximum");
        break;
      case Enums.PeakExceptionResponseCode.MerchantNameNotEqual:
        errorMessage = i18n.t("Merchant_Name_Not_Correct");
        break;
      case Enums.PeakExceptionResponseCode.UserIsNotAdmin:
        errorMessage = i18n.t("Can_Not_Delete_User_Not_Admin");
        break;
      case Enums.PeakExceptionResponseCode.ReconciledAlready:
        errorMessage = i18n.t("Document_Has_Been_Reconcile");
        break;
      case Enums.PeakExceptionResponseCode.PaymentTransactionIsReconciled:
        errorMessage = i18n.t("Document_Has_Been_Reconcile");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidBecauseJournalAccountIsReconciled:
        errorMessage = i18n.t("Lock_By_Reconcile_Tooltip");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateContactPersonHaveMaximum:
        errorMessage = i18n.t("Alert_ContactPerson_FreePackage");
        break;
      case Enums.PeakExceptionResponseCode.FreePackageCannotCreateNewFinanceAccount:
        errorMessage = i18n.t("Add_Finance_Failed_Please_Upgrade_Package");
        break;
      case Enums.PeakExceptionResponseCode.FreePackageCannotCreateNewAccount:
        errorMessage = i18n.t("Add_Account_Failed_Please_Upgrade_Package");
        break;
      case Enums.PeakExceptionResponseCode.FreePackageNotAllowedSelectChartOfAccount:
        errorMessage = i18n.t("Your_Package_Not_Allowed_To_Select_ChartOfAccount");
        break;
      case Enums.PeakExceptionResponseCode.FreePackageProductIsHaveMaximum:
        errorMessage = i18n.t("Add_Product_Failed_Please_Upgrade_Package");
        break;
      case Enums.PeakExceptionResponseCode.OverPaidReferenceDocumentPayment:
        errorMessage = i18n.t("Cannot_Paid_More_Than_The_Referenced_Documents");
        break;
      case Enums.PeakExceptionResponseCode.CanNotVoidBankCauseByHaveBankInSCBQR:
        errorMessage = i18n.t("Confirm_Cannot_Void_ThisBank");
        break;
      case Enums.PeakExceptionResponseCode.UnableToMakeBankReconciled:
        errorMessage = i18n.t("Unable_Make_Bank_Reconciled");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateDocumentsDatingBackUpToTwoMonths:
        errorMessage = i18n.t("Cannot_Create_Documents_Dating_Back_Two_Months");
        break;
      case Enums.PeakExceptionResponseCode.InvalidShopeeAuthenticationData:
      case Enums.PeakExceptionResponseCode.InvalidBentoWebAuthenticationData:
      case Enums.PeakExceptionResponseCode.InvalidLineMyShopAuthenticationData:
        errorMessage = i18n.t("Token_Already_Used");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateOrUpdatePaymentBankStatement:
        errorMessage = i18n.t("Can_Not_Import_File_Because_Invalid_Payload");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateBecauseHaveRecordZeroAmount:
        errorMessage = i18n.t("Can_Not_Import_File_Because_File_Have_Zero_Amount_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateBecauseNotSupportMultipleBankAccount:
        errorMessage = i18n.t("The_System_Not_Support_Multiple_Bank_Account_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditRecordDeleted:
        errorMessage = i18n.t("You_Can_Not_Edit_The_Deleted_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.UpgradeToPackageErrorCode:
        errorMessage = i18n.t("Unable_Change_Current_To_New_Package", {
          currentPackage: packageHelper.GetPackageName(exception.content.currentPackage),
          newPackage: packageHelper.GetPackageName(exception.content.newPackage),
        });
        break;
      case Enums.PeakExceptionResponseCode.ApprovedTransactionDuplicated:
        errorMessage = i18n.t("Approve_Failed_Because_This_Document_Has_Already_Been_Approved");
        break;
      case Enums.PeakExceptionResponseCode.TransactionNewStatusCannotLessThanCurrentStatus:
        errorMessage = i18n.t("Document_Cannot_Submitted_For_Approval_Because_Already_Approved");
        break;
      case Enums.PeakExceptionResponseCode.TransactionCurrentStatusCannotBeRejected:
        errorMessage = i18n.t("Document_Cannot_Disapproved_Because_Already_Approved");
        break;
      case Enums.PeakExceptionResponseCode.IssuedDuplicatedTaxInvoice:
        errorMessage = i18n.t("Alert_IssuedDuplicatedTaxInvoice");
        break;
      case Enums.PeakExceptionResponseCode.LockBySendEtaxInvoice:
        errorMessage = i18n.t("Lock_By_Send_Etax_Invoice");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditInvoiceBecauseDocumentHasBeenReferredToOtherDocument:
        errorMessage = i18n.t("Alert_CanNot_Edit_Invoice_Document");
        break;
      case Enums.PeakExceptionResponseCode.ContactPersonNamePrefixOtherMaxLength:
      case Enums.PeakExceptionResponseCode.ContactNamePrefixOtherMaxLength:
        errorMessage = i18n.t("Contact_Prefix_Incorrect_Format");
        break;
      case Enums.PeakExceptionResponseCode.AuthorityRoleNotPermission:
        errorMessage = i18n.t("Authority_Role_Not_Permission");
        break;
      case Enums.PeakExceptionResponseCode.IssuedTaxInvoiceDuplicated:
        errorMessage = i18n.t("Issued_TaxInvoice_Duplicated");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditQuantityTransactionReferenceQuotation:
        errorMessage = i18n.t("Create_Failed_Because_Specify_Quantity");
        break;
      case Enums.PeakExceptionResponseCode.QuotationCreatedTransaction:
        errorMessage = i18n.t("Create_Failed_Reference_Document_Successful");
        break;
      case Enums.PeakExceptionResponseCode.CanNotIssuedTaxInvoiceNotVat:
        errorMessage = i18n.t("Can_Not_Issued_TaxInvoice_Not_Vat");
        break;
      case Enums.PeakExceptionResponseCode.CannotCreateReceivedTaxInvoiceCauseByDocumentEdited:
        errorMessage = i18n.t("Alert_Cannot_CreateReceivedTaxInvoice_DocumentEdited");
        break;
      case Enums.PeakExceptionResponseCode.ProductTemplateIsNotHaveVatType:
        errorMessage = i18n.t("Please_Specify_The_Type_Of_VAT_Item");
        break;
      case Enums.PeakExceptionResponseCode.PriceOverQuotation:
        errorMessage = i18n.t("PriceOverQuotation_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditPriceTransactionReferenceQuotation:
        errorMessage = i18n.t("CanNotEditPriceTransactionReferenceQuotation_Exception");
        break;
      case Enums.PeakExceptionResponseCode.QuantityOverQuotation:
        errorMessage = i18n.t("QuantityOverQuotation_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditQuantityTransactionReferenceQuotation:
        errorMessage = i18n.t("CanNotEditQuantityTransactionReferenceQuotation_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotAddNewTransactionItemReferenceQuotation:
        errorMessage = i18n.t("CanNotAddNewTransactionItemReferenceQuotation_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateCreditNoteBecauseReferenceBillingNote:
        errorMessage = i18n.t("CanNotCreateCreditNoteBecauseReferenceBillingNote_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateDebitNoteBecauseReferenceBillingNote:
        errorMessage = i18n.t("CanNotCreateDebitNoteBecauseReferenceBillingNote_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ReceivedTaxInvoiceVatTotalOverflow:
        errorMessage = i18n.t("ReceivedTaxInvoiceVatTotalOverflow_Exception", { documentNo: exception.content });
        break;
      case Enums.PeakExceptionResponseCode.LimitProductImage:
        errorMessage = i18n.t("LimitProductImage_Exception");
        break;
      case Enums.PeakExceptionResponseCode.UnableToAddPEAKSupport:
        errorMessage = i18n.t("UnableToAddPEAKSupport_Exception");
        break;
      case Enums.PeakExceptionResponseCode.OverLimitAsset:
        errorMessage = i18n.t("OverLimitAsset_Exception");
        break;
      case Enums.PeakExceptionResponseCode.BillingNoteIsNotShowTransactionItem:
        errorMessage = i18n.t("BillingNoteIsNotShowTransactionItem_Exception");
        break;
      case Enums.PeakExceptionResponseCode.UpdateStatusTransactionIsDeleted:
        errorMessage = i18n.t("UpdateStatusTransactionIsDeleted_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditTransactionAsset:
      case Enums.PeakExceptionResponseCode.AssetNotFound:
        errorMessage = i18n.t("AssetNotFound_Exception");
        break;
      case Enums.PeakExceptionResponseCode.EmailVerificationCannotResendLessOneMinute:
        errorMessage = i18n.t("EmailVerificationCannotResendLessOneMinute_Exception");
        break;
      case Enums.PeakExceptionResponseCode.EmailVerificationCannotResendUserVerifiedEmailComplete:
        errorMessage = i18n.t("EmailVerificationCannotResendUserVerifiedEmailComplete_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ResendEmailDataInvalid:
        errorMessage = i18n.t("ResendEmailDataInvalid_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ResetEmailExpired:
        errorMessage = i18n.t("ResetEmailExpired_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ResetEmailAlready:
        errorMessage = i18n.t("ResetEmailAlready_Exception");
        break;
      case Enums.PeakExceptionResponseCode.CreditLimitCannontCreate:
        errorMessage = i18n.t("Extension_CreditLimit_Amount");
        break;
      case Enums.PeakExceptionResponseCode.BankAccountNotFound:
        errorMessage = i18n.t("Extension_BankAccount_NotFound");
        break;
      case Enums.PeakExceptionResponseCode.CanNotActionBecauseTransactionHaveDeposit:
        errorMessage = i18n.t("Action_NotSupport_TransactionHaveDeposit");
        break;
      case Enums.PeakExceptionResponseCode.RemainingGoodsReceiptNotMatchInvoiceReceipt:
        errorMessage = i18n.t("RemainingGoodsReceiptNotMatchInvoiceReceipt_Exception");
        break;
      case Enums.PeakExceptionResponseCode.GoodsReceiptNotMatchInvoiceReceipt:
        errorMessage = i18n.t("GoodsReceiptAlreadyIssueInvoiceReceipt_Exception");
        break;
      case Enums.PeakExceptionResponseCode.GoodsReceiptNotMatchInvoiceReceiptPricingType:
        errorMessage = i18n.t("GoodsReceiptNotMatchInvoiceReceiptPricingType_Exception");
        break;
      case Enums.PeakExceptionResponseCode.GoodsReceiptNotMatchInvoiceReceiptSummary:
        errorMessage = i18n.t("GoodsReceiptNotMatchInvoiceReceiptSummary_Exception");
        break;
      case Enums.PeakExceptionResponseCode.DepositAlreadyIssued:
        errorMessage = i18n.t("DepositAlreadyIssued_Exception");
        break;
      case Enums.PeakExceptionResponseCode.LimitTransactionValueOverFlow:
        errorMessage = i18n.t("LimitTransactionValueOverFlow_Exception");
        break;
      case Enums.PeakExceptionResponseCode.UpgradePackageIsAlreadyUpgraded:
        errorMessage = i18n.t("Alert_UpgradePackage_AlreadyUpgraded");
        break;
      case Enums.PeakExceptionResponseCode.QuotationAlreadyIssueInvoice:
        errorMessage = i18n.t("Alert_TransactionAlreadyIssueReference");
        break;
      case Enums.PeakExceptionResponseCode.QuotationAlreadyIssueDeposit:
        errorMessage = i18n.t("Alert_TransactionAlreadyIssueReference");
        break;
      case Enums.PeakExceptionResponseCode.QuotationAlreadyIssueReceipt:
        errorMessage = i18n.t("Alert_TransactionAlreadyIssueReference");
        break;
      case Enums.PeakExceptionResponseCode.QuotationAlreadyIssueGoodsReceipt:
        errorMessage = i18n.t("Alert_TransactionAlreadyIssueReference");
        break;
      case Enums.PeakExceptionResponseCode.QuotationAlreadyIssueInvoiceReceipt:
        errorMessage = i18n.t("Alert_TransactionAlreadyIssueReference");
        break;
      case Enums.PeakExceptionResponseCode.ErrorTransactionIsHaveVat:
        errorMessage = i18n.t("ErrorTransactionIsHaveVat_Exception");
        break;
      case Enums.PeakExceptionResponseCode.DebitNoteContactDiff:
        errorMessage = i18n.t("DebitNoteContactDiff_Exception");
        break;
      case Enums.PeakExceptionResponseCode.TransactionStatusChanged:
      case Enums.PeakExceptionResponseCode.ReferenceTransactionIsVoided:
        errorMessage = i18n.t("TransactionStatusChanged_Exception");
        break;
      case Enums.PeakExceptionResponseCode.DebitNoteDateLessThanReferenceTransactionDate:
        errorMessage = i18n.t("DebitNoteDateLessThanReferenceTransactionDate_Exception");
        break;
      case Enums.PeakExceptionResponseCode.EmailNotVerify:
        errorMessage = i18n.t("This_Feature_Avaliable_After_Verify_Email");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEasyEditTransactionItemProductReferenceQuotation:
        errorMessage = i18n.t("Cannot_Edit_Reference_Quotation_Item_Product");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEasyEditTransactionItemAccountReferenceQuotation:
        errorMessage = i18n.t("Cannot_Edit_Reference_Quotation_Item_Account");
        break;
      case Enums.PeakExceptionResponseCode.PaymentMethodOverLimit:
        errorMessage = i18n.t("Payment_Method_Over_Limit");
        break;
      case Enums.PeakExceptionResponseCode.BankStatementIsReconciled:
        errorMessage = i18n.t("BankStatementIsReconciled_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ReferenceQuotationIsVoided:
        errorMessage =
          exception.content.financeType === Enums.FinanceType.InFlow
            ? i18n.t("Cannot_Create_Transaction_From_Voided_Quotation")
            : exception.content.transactionItemType === Enums.TransactionItemType.Asset
            ? i18n.t("Cannot_Create_Transaction_From_Voided_Purchase_Order_Asset")
            : i18n.t("Cannot_Create_Transaction_From_Voided_Purchase_Order");
        break;
      case Enums.PeakExceptionResponseCode.AllocationError:
        errorMessage = i18n.t("Please_Fill_Fully_Amount_Or_One_Hundred_Percent");
        break;
      case Enums.PeakExceptionResponseCode.PurchaseRequisitionAlreadyIssueTransaction:
        errorMessage = i18n.t("PurchaseRequisition_Already_Issue_Transaction");
        break;
      case Enums.PeakExceptionResponseCode.MainEmailAndAlterNativeEmailDuplicate:
        errorMessage = i18n.t("Alternative_Email_Duplicate");
        break;
      case Enums.PeakExceptionResponseCode.BankAccountNotSupportEWitholdingTax:
        errorMessage = i18n.t("Validate_Payment_Transfer.Invalid_Wht_Category_Short_Message");
        break;
      case Enums.PeakExceptionResponseCode.ImportDetailCodeLimitExceed:
        errorMessage = i18n.t("ImportDetailCodeLimitExceed");
        break;
      case Enums.PeakExceptionResponseCode.CanNotEditWhtDebitNoteIsReference:
        errorMessage = i18n.t("Cannot_Edit_This_Information_Exception");
        break;
      case Enums.PeakExceptionResponseCode.ProductNotFound:
        errorMessage = i18n.t("Import_Detail_Product_NotFound");
        break;
      case Enums.PeakExceptionResponseCode.CanNotCreateAndRefDocumentIsReferenceTransaction:
        errorMessage = i18n.t("Alert_Files_Already_CreatedOrAttached");
        break;
      case Enums.PeakExceptionResponseCode.UserHasBeenDeleted:
        errorMessage = i18n.t("This_User_Has_Been_Removed");
        break;
      case Enums.PeakExceptionResponseCode.AssetTemplateCodeDuplicated:
        errorMessage = i18n.t("general.wanting_duplicate_asset_group");
        break;
      case Enums.PeakExceptionResponseCode.PurchaseDateLessThanDepreciateDate:
        errorMessage = i18n.t("alert.purchase_date_less_than_depreciate_date");
        break;
      default:
        errorMessage = exception.code
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
          : i18n.t("Something_Wrong");
        break;
    }

    return errorMessage;
  },
  GetAppConnectErrorMessageByExceptionCode(exception) {
    let errorMessage = "";

    switch (exception.exceptionCode) {
      case Enums.AppConnectExceptionResponseCode.Page365Error:
        errorMessage = this.GetPage365ErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.BentoWebError:
        errorMessage = this.GetBentoWebErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.LineMyShopError:
        errorMessage = this.GetLineMyShopErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.ShopeeError:
        errorMessage = this.GetShopeeErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.LazadaError:
        errorMessage = this.GetLazadaErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.MatchLinkError:
        errorMessage = this.GetMatchLinkErrorMessageByErrorCodeDetail(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.SCB:
        errorMessage = this.GetSCBErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.PaySolutionError:
        errorMessage = this.GetPaySolutionErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.Bay:
        errorMessage = this.GetBayErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.Beam:
        errorMessage = this.GetBeamErrorMessageByErrorCode(exception);
        break;
      case Enums.AppConnectExceptionResponseCode.ChillPay:
        errorMessage = this.GetChillPayErrorMessageByErrorCode(exception);
        break;
      default:
        errorMessage = exception.exceptionCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.exceptionCode}`
          : i18n.t("Something_Wrong");
        break;
    }

    return errorMessage;
  },
  GetVirtualCFOErrorMessageByExceptionCode(exception) {
    let errorMessage = "";
    switch (exception ? exception.code : null) {
      default:
        errorMessage = exception.code
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.code}`
          : i18n.t("Something_Wrong");
        break;
    }

    return errorMessage;
  },
  GetPage365ErrorMessageByErrorCode(exception) {
    let errorMessage = "";

    switch (exception.errorCode) {
      case Enums.Page365ErrorCode.InvalidToken:
        errorMessage = i18n.t("Merchant_Token_Invalid");
        break;
      case Enums.Page365ErrorCode.UnauthorizeToken:
        errorMessage = i18n.t("Page365_Unauthorize_Token");
        break;
      case Enums.Page365ErrorCode.UnauthorizeConfigToken:
        errorMessage = i18n.t("App_Connect_Unauthorize_Config_Token");
        break;
      case Enums.Page365ErrorCode.DuplicateShop:
        if (exception.detail) {
          errorMessage = i18n.t("Connect_Ecommerce_Error_Duplicate_Shop", { merchantName: exception.detail.content });
        }
        break;
      default:
        errorMessage = exception.detail.errorMessage
          ? `${i18n.t("Something_Wrong")} Error Message : ${exception.detail.errorMessage}`
          : i18n.t("Something_Wrong");
        break;
    }

    return errorMessage;
  },
  GetBentoWebErrorMessageByErrorCode(exception) {
    let errorMessage = "";

    switch (exception.errorCode) {
      case Enums.BentoWebErrorCode.InvalidToken:
        errorMessage = i18n.t("Connect_Fail_Token_Invalid", { name: "BentoWeb" });
        break;
      case Enums.BentoWebErrorCode.InvalidProductVariant:
        errorMessage = i18n.t("Connect_BentoWeb_Fail_Product_Invalid");
        break;
      case Enums.BentoWebErrorCode.UnauthorizeConfigToken:
        errorMessage = i18n.t("App_Connect_Unauthorize_Config_Token");
        break;
      case Enums.BentoWebErrorCode.Default:
        if (exception.detail) {
          errorMessage = this.GetErrorMessageByExceptionCode(exception.detail);
        }
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }

    return errorMessage;
  },
  GetLineMyShopErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.LineMyShopErrorCode.InvalidAccessToken:
        if (exception.detail && exception.detail.code) {
          errorMessage = this.GetErrorMessageByExceptionCode(exception.detail);
        } else {
          errorMessage = i18n.t("Connect_Fail_Token_Invalid", { name: "LINE SHOPPING" });
        }
        break;
      case Enums.LineMyShopErrorCode.Default:
        if (exception.detail) {
          errorMessage = this.GetErrorMessageByExceptionCode(exception.detail);
        }
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetShopeeErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.ShopeeErrorCode.InvalidAccessToken:
        errorMessage = i18n.t("Connect_Fail_Token_Invalid", { name: "Shopee" });
        break;
      case Enums.ShopeeErrorCode.UnauthorizeConfigToken:
        errorMessage = i18n.t("App_Connect_Unauthorize_Config_Token");
        break;
      case Enums.ShopeeErrorCode.DuplicateShop:
        if (exception.detail) {
          errorMessage = i18n.t("Connect_Ecommerce_Error_Duplicate_Shop", { merchantName: exception.detail.content });
        }
        break;
      case Enums.ShopeeErrorCode.Default:
        if (exception.detail) {
          errorMessage = this.GetErrorMessageByExceptionCode(exception.detail);
        }
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetLazadaErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.LazadaErrorCode.InvalidAccessToken:
        errorMessage = i18n.t("Connect_Fail_Token_Invalid", { name: "Lazada" });
        break;
      case Enums.LazadaErrorCode.UnauthorizeConfigToken:
        errorMessage = i18n.t("App_Connect_Unauthorize_Config_Token");
        break;
      case Enums.ShopeeErrorCode.DuplicateShop:
        if (exception.detail) {
          errorMessage = i18n.t("Connect_Ecommerce_Error_Duplicate_Shop", { merchantName: exception.detail.content });
        }
        break;
      case Enums.LazadaErrorCode.Default:
        if (exception.detail) {
          errorMessage = this.GetErrorMessageByExceptionCode(exception.detail);
        }
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetMatchLinkErrorMessageByErrorCodeDetail(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.MatchLinkErrorCode.Default:
        errorMessage = i18n.t("MatchLink_Error_Default");
        break;
      case Enums.MatchLinkErrorCode.Unauthorize:
        errorMessage = i18n.t("MatchLink_Error_Unauthorize");
        break;
      case Enums.MatchLinkErrorCode.Claimed:
        errorMessage = i18n.t("MatchLink_Error_Claimed");
        break;
      case Enums.MatchLinkErrorCode.NotAcceptAgreement:
        errorMessage = i18n.t("MatchLink_Error_NotAcceptAgreement");
        break;
      case Enums.MatchLinkErrorCode.InvalidOrMissingVerificationData:
        errorMessage = i18n.t("Registration_Number_Incorrect_Please_Enter");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetSCBErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.SCBErrorCode.CantGetSCBQRCodePayment:
        errorMessage = i18n.t("Invalid_Biller_ID_Please_Check");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetPaySolutionErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.PaySolutionErrorCode.CantGetInquiryAPI:
        errorMessage = i18n.t("Invalid_PaySolution_Info_Please_Check");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetBeamErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.BeamErrorCode.CantGetPurchase:
        errorMessage = i18n.t("Invalid_Beam_Info_Please_Check");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetBayErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.BayErrorCode.BayStatementCantGetToken:
        errorMessage = i18n.t("Invalid_BayStatement_Please_Check");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetChillPayErrorMessageByErrorCode(exception) {
    let errorMessage = "";
    switch (exception.errorCode) {
      case Enums.ChillPayErrorCode.CantGetChillPayPayment:
        errorMessage = i18n.t("Invalid_ChillPay_Info_Please_Check");
        break;
      case Enums.ChillPayErrorCode.PaymentUrlNotFound:
        errorMessage = i18n.t("กรุณากรอก Payment URL ใน ChillPay Setting");
        break;
      default: {
        errorMessage = exception.errorCode
          ? `${i18n.t("Something_Wrong")} Error Code : ${exception.errorCode}`
          : i18n.t("Something_Wrong");
        break;
      }
    }
    return errorMessage;
  },
  GetTypeOfPersonBySearchedAddress(merchantType) {
    switch (merchantType) {
      case Enums.MerchantType.OrdinaryPerson:
      case Enums.MerchantType.OrdinaryPartnership:
      case Enums.MerchantType.Shop:
      case Enums.MerchantType.BodyOfPersons:
        return { name: i18n.t("Ordinary_Person"), value: Enums.TypeOfPerson.OrdinaryPerson };
        break;
      case Enums.MerchantType.JointVenture:
      case Enums.MerchantType.Association:
      case Enums.MerchantType.Foundation:
      case Enums.MerchantType.LimitedLiabilityPartnership:
      case Enums.MerchantType.PublicCompanyLimited:
      case Enums.MerchantType.CompanyLimited:
      case Enums.MerchantType.Others:
        return { name: i18n.t("Legal_Entity"), value: Enums.TypeOfPerson.JuristicPerson };
        break;

      default:
        return { name: i18n.t("Legal_Entity"), value: Enums.TypeOfPerson.JuristicPerson };
        break;
    }
  },
  GetWithheldList() {
    return [
      { name: i18n.t("Not_specify"), value: Enums.WhtAmountType.NotSpecify.type },
      { name: i18n.t("None"), value: Enums.WhtAmountType.None.type },
      { name: "0.75%", value: Enums.WhtAmountType.ZeroPointSevenFive.type },
      { name: "1%", value: Enums.WhtAmountType.OnePercent.type },
      { name: "1.5%", value: Enums.WhtAmountType.OnePointFivePercent.type },
      { name: "2%", value: Enums.WhtAmountType.TwoPercent.type },
      { name: "3%", value: Enums.WhtAmountType.ThreePercent.type },
      { name: "5%", value: Enums.WhtAmountType.FivePercent.type },
      { name: "10%", value: Enums.WhtAmountType.TenPercent.type },
      { name: "15%", value: Enums.WhtAmountType.FifteenPercent.type },
      { name: i18n.t("Custom"), value: Enums.WhtAmountType.Custom.type },
    ];
  },
  GetTrackingGoogleFacebookType(trackingType) {
    let google = "";
    let facebook = "";

    switch (trackingType) {
      case Enums.TrackingGoogleFacebookType.AddToWishList:
        google = "qpkECKiG-uADEIzSkswD";
        facebook = "AddToWishlist";
        break;
      case Enums.TrackingGoogleFacebookType.StartTrial:
        google = "ZVS-CKD--eADEIzSkswD";
        facebook = "StartTrial";
        break;
      case Enums.TrackingGoogleFacebookType.Subscribe:
        google = "0jXZCKP--eADEIzSkswD";
        facebook = "Subscribe";
        break;
    }

    return { google, facebook };
  },
  NewObject(object) {
    let newObject = null;
    if (object) {
      newObject = JSON.parse(JSON.stringify(object));
    } else {
      newObject = object;
    }
    return newObject;
  },
  SetPeriodTimeByFromDateToDate(fromDate, toDate) {
    let periodTimeType = Enums.TrialBalancePeriodType.Custom;
    let dateTimeNow = new Date();
    //this month
    let firstDateThisMonth = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), 1);
    let endDateThisMonth = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth() + 1, 0);
    //last month
    let firstDateLastMonth = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth() - 1, 1);
    let endDateLastMonth = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), 0);
    //this year
    let firstDateThisYear = new Date(dateTimeNow.getFullYear(), 0, 1);
    let endDateThisYear = new Date(dateTimeNow.getFullYear() + 1, 0, 0);
    //last year
    let firstDateLastYear = new Date(dateTimeNow.getFullYear() - 1, 0, 1);
    let endDateLastYear = new Date(dateTimeNow.getFullYear(), 0, 0);
    if (
      fromDate.ToDateJsonString() == firstDateThisMonth.ToDateJsonString() &&
      toDate.ToDateJsonString() == endDateThisMonth.ToDateJsonString()
    ) {
      periodTimeType = Enums.TrialBalancePeriodType.ThisMonth;
    } else if (
      fromDate.ToDateJsonString() == firstDateLastMonth.ToDateJsonString() &&
      toDate.ToDateJsonString() == endDateLastMonth.ToDateJsonString()
    ) {
      periodTimeType = Enums.TrialBalancePeriodType.LastMonth;
    } else if (
      fromDate.ToDateJsonString() == firstDateLastMonth.ToDateJsonString() &&
      toDate.ToDateJsonString() == endDateLastMonth.ToDateJsonString()
    ) {
      periodTimeType = Enums.TrialBalancePeriodType.LastMonth;
    } else if (
      fromDate.ToDateJsonString() == firstDateThisYear.ToDateJsonString() &&
      toDate.ToDateJsonString() == endDateThisYear.ToDateJsonString()
    ) {
      periodTimeType = Enums.TrialBalancePeriodType.ThisYear;
    } else if (
      fromDate.ToDateJsonString() == firstDateLastYear.ToDateJsonString() &&
      toDate.ToDateJsonString() == endDateLastYear.ToDateJsonString()
    ) {
      periodTimeType = Enums.TrialBalancePeriodType.Lastyear;
    }
    return periodTimeType;
  },
  GetDayOfWeekOptions() {
    return [
      { name: i18n.t("Monday"), value: Enums.DayType.Monday },
      { name: i18n.t("Tuesday"), value: Enums.DayType.Tuesday },
      { name: i18n.t("Wednesday"), value: Enums.DayType.Wednesday },
      { name: i18n.t("Thursday"), value: Enums.DayType.Thursday },
      { name: i18n.t("Friday"), value: Enums.DayType.Friday },
      { name: i18n.t("Saturday"), value: Enums.DayType.Saturday },
      { name: i18n.t("Sunday"), value: Enums.DayType.Sunday },
    ];
  },
  GetDayOfMonthOptions() {
    return [
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 },
      { name: 6, value: 6 },
      { name: 7, value: 7 },
      { name: 8, value: 8 },
      { name: 9, value: 9 },
      { name: 10, value: 10 },
    ];
  },
  SetCookie(cookieName, value, expireDays) {
    if (this.IsSetCookiesInDomain()) {
      Cookies.set(cookieName, value, { expires: expireDays, domain: peakDomain });
    } else {
      Cookies.set(cookieName, value, { expires: expireDays });
    }
  },
  GetCookie(cookieName) {
    return Cookies.get(cookieName);
  },
  DeleteCookie(cookieName) {
    if (this.IsSetCookiesInDomain()) {
      Cookies.remove(cookieName, { domain: peakDomain });
    } else {
      Cookies.remove(cookieName);
    }
  },
  CheckInputValidateError(fields, isAlreadyError) {
    if (!isAlreadyError) {
      Object.values(fields).forEach((field) => {
        if (!isAlreadyError && field.validateError) {
          isAlreadyError = field.validateError;
        }
      });
    }
    return isAlreadyError;
  },
  MissionActionTrack(trackingType) {
    const trackingName = this.GetTrackingGoogleFacebookType(trackingType);
    gtag("event", "conversion", {
      send_to: `AW-964995340/${trackingName.google}`,
    });
    fbq("track", trackingName.facebook);
  },
  GetTextSearchDate(fromDate, toDate) {
    if (!fromDate && !toDate) {
      return i18n.t("Select_Date_For_Search");
    } else if (!fromDate && toDate) {
      return i18n.t("Before_Date_For_Search", { date: toDate.GetDateFormat() });
    } else if (fromDate && !toDate) {
      return i18n.t("Onwards_Date_For_Search", { date: fromDate.GetDateFormat() });
    } else if (fromDate && toDate) {
      return `${fromDate.GetDateFormat()} - ${toDate.GetDateFormat()}`;
    } else {
      return "";
    }
  },
  GetTextSearchNetAmount(fromNetAmount, toNetAmount) {
    if (!fromNetAmount && !toNetAmount) {
      return i18n.t("Select_NetAmount_For_Search");
    } else if (!fromNetAmount && toNetAmount) {
      return i18n.t("LessThan_NetAmount_For_Search", { netAmount: toNetAmount.FormatMoney() });
    } else if (fromNetAmount && !toNetAmount) {
      return i18n.t("Onwards_NetAmount_For_Search", { netAmount: fromNetAmount.FormatMoney() });
    } else if (fromNetAmount && toNetAmount) {
      return `${fromNetAmount.FormatMoney()} - ${toNetAmount.FormatMoney()}`;
    } else {
      return "";
    }
  },
  CheckLeastOneUppercaseLetter(text) {
    const leastOneUppercaseLetter = new RegExp("^(?=.*[A-Z])");
    return leastOneUppercaseLetter.test(text);
  },
  CheckLeastOneNumber(text) {
    const leastOneNumber = new RegExp("^(?=.*[0-9])");
    return leastOneNumber.test(text);
  },
  CheckLeastEightCharacters(text) {
    const leastEightCharacters = new RegExp("^(?=.{8,})");
    return leastEightCharacters.test(text);
  },
  CheckLeastOneSpecialCharacter(text) {
    const leastOneSpecialCharacter = new RegExp("^(?=.*[-!@#$%^&*~`()+=_{}|;:<>,.?\"'])");
    return leastOneSpecialCharacter.test(text);
  },
  CheckMaxlengthEmail(email) {
    return email && email.length <= 256;
  },
  CheckMaxlengthPassword(password) {
    return password && password.length <= 40;
  },
  GetTextByLimitCharacter(text, limit) {
    if (!text) return;
    if (text.length <= limit) return text;
    return text.slice(0, limit);
  },
  DecodeJwtResponse(credential) {
    return JSON.parse(Buffer.from(credential.split(".")[1], "base64").toString());
  },
  IsSetCookiesInDomain() {
    let isSetDomain = false;

    if (peakDomain) {
      const domainList = location.hostname.split(".");
      const start = -(domainList.length - 1);
      const locationDomain = `.${domainList.slice(start).join(".")}`;

      if (locationDomain == peakDomain) {
        isSetDomain = true;
      }
    }

    return isSetDomain;
  },
  UnsetOverflowModalBox(unsetOverflow) {
    const elementIdList = document.querySelectorAll("[id='modalBox']");
    if (elementIdList.length > 0) {
      elementIdList.forEach((elementId) => {
        let element = null;
        element = elementId.getElementsByClassName("modalBox")[0];
        if (element) {
          if (unsetOverflow) {
            element.className += " unsetOverflow";
          } else {
            const classArray = element.className.split(" ");
            const index = classArray.indexOf("unsetOverflow");
            if (index !== -1) {
              classArray.splice(index, 1);
              element.className = classArray.join(" ");
            }
          }
        }
      });
    }
  },
  CheckInAppTutorial(userInAppSuggestion) {
    let inAppTutorial = false;
    if (userInAppSuggestion.currentUserInAppType === Enums.inAppSuggestion.inAppTutorial) {
      const inAppTutorialList = userInAppSuggestion.inAppSuggestionData.filter(
        (item) => item.inAppType === Enums.inAppSuggestion.inAppTutorial
      );
      if (inAppTutorialList.length === 0) {
        inAppTutorial = true;
      }
    }
    return inAppTutorial;
  },
  CheckInAppManualGuide(userInAppSuggestion) {
    let inAppManualGuide = false;
    const inAppManualGuideList = userInAppSuggestion.inAppSuggestionData.filter(
      (item) => item.inAppType === Enums.inAppSuggestion.inAppManualGuide
    );
    if (
      userInAppSuggestion.currentUserInAppType === Enums.inAppSuggestion.inAppManualGuide &&
      inAppManualGuideList.length === 0
    ) {
      inAppManualGuide = true;
    } else if (
      userInAppSuggestion.currentUserInAppType === Enums.inAppSuggestion.inAppTutorial &&
      inAppManualGuideList.length === 0
    ) {
      inAppManualGuide = true;
    }
    return inAppManualGuide;
  },
  CheckShouldShowInAppManualGuide(userInAppSuggestion) {
    let shouldShowInAppManualGuide = false;
    const inAppManualGuideList = userInAppSuggestion.inAppSuggestionData.filter(
      (item) => item.inAppType === Enums.inAppSuggestion.inAppManualGuide
    );
    if (inAppManualGuideList.length === 0) {
      shouldShowInAppManualGuide = true;
    }
    return shouldShowInAppManualGuide;
  },
  CheckInAppScreenWidth() {
    const isMdScreenWidth = window.screen.width > 768; // 768px = tablet width
    return isMdScreenWidth;
  },
  AddDetectTabClosing() {
    window.addEventListener("beforeunload", DetectTabClosing);
  },
  RemoveDetectTabClosing() {
    window.removeEventListener("beforeunload", DetectTabClosing);
  },
  IsHEIC(file) {
    // check file extension since windows returns blank mime for heic
    let x = file.fileType ? file.fileType.split("image/").pop() : file.fileName.split(".").pop().toLowerCase();
    return x == "heic" || x == "heif";
  },
  AddHEICtoFileType(fileList) {
    fileList.forEach((file) => {
      if (this.IsHEIC(file)) {
        file.fileType = "image/heic";
      }
    });
  },
  CheckInAppPeakExpSettings(userInAppSuggestion) {
    let inAppPeakExpSettings = false;
    const inAppPeakExpSettingsList = userInAppSuggestion.inAppSuggestionData.filter(
      (item) => item.inAppType === Enums.inAppSuggestion.inAppPeakExpSettings
    );
    if (inAppPeakExpSettingsList.length === 0) {
      inAppPeakExpSettings = true;
    }
    return inAppPeakExpSettings;
  },
  CreateMetaTagProperty(property, content) {
    let meta = document.createElement("meta");
    meta.setAttribute("property", property);
    meta.setAttribute("content", content);
    document.getElementsByTagName("head")[0].appendChild(meta);
  },
  CreateMetaTagName(name, content) {
    let meta = document.createElement("meta");
    meta.setAttribute("name", name);
    meta.setAttribute("content", content);
    document.getElementsByTagName("head")[0].appendChild(meta);
  },
  RemoveMetaTagProperty(property) {
    const existingMeta = document.querySelector(`[property='${property}']`);
    if (existingMeta) {
      existingMeta.remove();
    }
  },
  RemoveMetaTagName(name) {
    const existingMeta = document.querySelector(`[name='${name}']`);
    if (existingMeta) {
      existingMeta.remove();
    }
  },
  CreateElementSpanAttributes(id, text, attributesName) {
    const spanTag = document.createElement("span");

    spanTag.id = attributesName ? `${attributesName}${id}` : id;
    spanTag.style.color = "#3297ff";
    spanTag.style.fontFamily = "Maibork-bold";

    spanTag.setAttribute("contenteditable", "false");
    const newContent = document.createTextNode(text);
    spanTag.appendChild(newContent);
    return spanTag;
  },
  InsertTextAtCaret(id, text, attributesName = "") {
    var sel, range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        const spaceStart = document.createTextNode("\u00A0");
        const spaceEnd = document.createTextNode("\u00A0");
        const spanTag = this.CreateElementSpanAttributes(id, text, attributesName);

        range.insertNode(spaceEnd);
        range.insertNode(spanTag);
        range.insertNode(spaceStart);

        range.setStartAfter(spaceEnd);
      }
    }
  },
  SetBannerThumbnailTTL() {
    const now = new Date();
    const midnightTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    localStorage.setItem("bannerThumbnail-expiration", midnightTomorrow.getTime());
  },
  CheckBannerThumbnailExpired(localStorageName) {
    const now = new Date();
    const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expiration = localStorage.getItem("bannerThumbnail-expiration");
    if (currentDate.getTime().toString() !== expiration) {
      localStorage.removeItem(localStorageName);
      localStorage.removeItem("bannerThumbnail-expiration");
      return false;
    }
    return true;
  },
  GetUserIdFromCommentText(commentText) {
    if (commentText) {
      const userIds = commentText.match(/\[\[userId\d+\]\]/g);
      if (userIds) {
        const extractedUserIds = userIds.map((userId) => Number(userId.match(/\d+/)[0]));
        return extractedUserIds;
      }
    }
    return [];
  },
  GetCommentTextForDisplay(commentText, otherUserListMap) {
    let commentTextForDisplay = commentText;
    if (commentText) {
      const userIds = commentText.match(/\[\[userId\d+\]\]/g);
      if (userIds && userIds.length > 0) {
        for (let userId of userIds) {
          const extractedUserId = Number(userId.match(/\d+/)[0]);
          const selectedUser = otherUserListMap[extractedUserId];
          if (selectedUser) {
            const userNameBox = `<span style="color:#3297ff;font-family: 'Maibork-bold';">@${selectedUser.displayName}</span>`;
            commentTextForDisplay = commentTextForDisplay.replaceAll(userId, userNameBox);
          }
        }
      }
    }
    return commentTextForDisplay;
  },
  GetKeyCookieHideModalAlertPackage(userId, merchantId) {
    return `hideModalAlertPackage${userId}-${merchantId}`;
  },
  GetKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  },
  GetLogFrom(fromSource) {
    switch (fromSource) {
      case Enums.ActivityLogSource.None:
      case Enums.ActivityLogSource.PEAK_Engine:
        return "PEAK";
      case Enums.ActivityLogSource.PEAK_Experience:
        return "NEW PEAK";
      case Enums.ActivityLogSource.PEAK_API:
        return "PEAK API";
      case Enums.ActivityLogSource.TransactionImport:
        return "Import Feature";
      case Enums.ActivityLogSource.ZORT:
        return "ZORT";
      case Enums.ActivityLogSource.KetShopWeb:
        return "KetShopWeb";
      case Enums.ActivityLogSource.XCommerce:
        return "xCommerce";
      case Enums.ActivityLogSource.BentoWeb:
        return "BentoWeb";
      case Enums.ActivityLogSource.Wisible:
        return "Wisible";
      case Enums.ActivityLogSource.Empeo:
        return "Empeo";
      case Enums.ActivityLogSource.Recurring:
        return "Recurring";
      case Enums.ActivityLogSource.BoxMe:
        return "BoxMe";
      case Enums.ActivityLogSource.LineConnect:
        return "LINE Connect";
      case Enums.ActivityLogSource.UCommerce:
        return "U-Commerce";
      case Enums.ActivityLogSource.Page365:
        return "Page365";
      case Enums.ActivityLogSource.LineMyShop:
        return "Line My Shop";
      case Enums.ActivityLogSource.Shopee:
        return "Shopee";
      case Enums.ActivityLogSource.Lazada:
        return "Lazada";
      case Enums.ActivityLogSource.PeakPayroll:
        return "PEAK Payroll";
      case Enums.ActivityLogSource.PeakTax:
        return "PEAK Tax";
      case Enums.ActivityLogSource.SCBQR:
        return "SCB QR Payment";
      case Enums.ActivityLogSource.BayQR:
        return "Krungsri Bill Payment";
      case Enums.ActivityLogSource.PaySolutionPayment:
        return "Pay Solutions";
      case Enums.ActivityLogSource.FileVault:
        return "File Vault";
      case Enums.ActivityLogSource.PeakAdmin:
        return "PEAK Admin";
      case Enums.ActivityLogSource.BblQR:
        return "BBL QR Code Collection";
      case Enums.ActivityLogSource.Beam:
        return "Beam Checkout";
      case Enums.ActivityLogSource.ChillPay:
        return "ChillPay";
      case Enums.ActivityLogSource.RequestTaxInvoice:
        return i18n.t("RequestTaxInvoice.Log");
      case Enums.ActivityLogSource.PeakMobile:
        return "PEAK Mobile";
      case Enums.ActivityLogSource.Shipnity:
        return "Shipnity";
      case Enums.ActivityLogSource.XSelly:
        return "Xselly";
      case Enums.ActivityLogSource.JSTERP:
        return "JSTERP";
      case Enums.ActivityLogSource.MCS:
        return "Miracle Clinic System";
      case Enums.ActivityLogSource.SeniorSoft:
        return "SeniorSoft";
      case Enums.ActivityLogSource.Jubili:
        return "JUBILI";
      case Enums.ActivityLogSource.PeakAsset:
        return "PEAK Asset";
      default:
        return "";
    }
  },
};
